import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=46dcad15&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46dcad15')) {
      api.createRecord('46dcad15', component.options)
    } else {
      api.reload('46dcad15', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=46dcad15&", function () {
      api.rerender('46dcad15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2can4wr2GjZRW/JS/starrating.vue"
export default component.exports